// extracted by mini-css-extract-plugin
export default {"root":"qNKYe","profile":"jGOLl","cashback":"QVqWb","userPhone":"GsKe8"};